import { atom } from 'jotai';
const status = atom(false)


export { status }
